import { render, staticRenderFns } from "./NewPermission.vue?vue&type=template&id=af76e72a&scoped=true&"
import script from "./NewPermission.vue?vue&type=script&lang=js&"
export * from "./NewPermission.vue?vue&type=script&lang=js&"
import style0 from "./NewPermission.vue?vue&type=style&index=0&id=af76e72a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af76e72a",
  null
  
)

export default component.exports